// import React from "react"
import styled from "styled-components"
import { rem } from "polished"

const Container = styled.div`
  // width: ${rem(1400)};
  max-width: 95%;
  width: 100%;
  // width: 100%;
  margin: 0 auto;
  padding-left: ${rem(20)};
  padding-right: ${rem(20)};

  @media ${props => props.theme.mobileDown} {
    // width: ${rem(375)};
    // margin-left: auto;
    // margin-right: auto;
    max-width: 100%;
    padding-left: ${rem(20)};
    padding-right: ${rem(20)};
  }

  @media ${props => props.theme.mobileUp} and ${props =>
  props.theme.desktopDown} {
    // width: 700px;
  }
`

export default Container
